(function () {
    'use strict';

    angular
        .module('app')
        .service('HttpAuthInterceptorService', HttpAuthInterceptorService);

    HttpAuthInterceptorService.$inject = ['global',];

    function HttpAuthInterceptorService(global) {
        var service = this;

        service.request = request;

        function request(config) {
            if (config.url.indexOf('api') !== -1) {
                if (global.user && global.user.userID && global.user.accessToken) {
                    config.headers.Authorization = 'Bearer ' + btoa(global.user.userID + ':' + global.user.accessToken);
                }

                if (config.method === 'POST' && config.data && config.data.id && !(config.params && config.params.overridePatch)) {
                    config.method = 'PATCH';
                }

                config.headers['Content-Type'] = 'application/json;charset=utf-8';
            }

            return config;
        }
    }

})();